import React, { lazy, Suspense, useContext, useState } from "react";
import firebase from "firebase/compat/app";
import {
  AppBar,
  IconButton,
  Toolbar,
  CircularProgress,
  Box,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Button,
} from "@mui/material";
import {
  Logout,
  MenuBook,
} from "@mui/icons-material";
import { BrowserRouter, useLocation } from "react-router-dom";
import AuthGuard, { UserContext } from "./components/AuthGuard";
import GeneralErrorPage from "./components/GeneralErrorPage";
import { ErrorBoundary } from "react-error-boundary";
import { LoggedInRouter } from "./LoggedInRouter";

const SignInScreen = lazy(() => import("./components/SignInScreen"));

function AppContent() {
  const user = useContext(UserContext);
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await firebase.auth().signOut();
    handleClose();
  };

  const isAuthPage = location.pathname === "/login";

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      {user && !isAuthPage && (
        <AppBar position="static" elevation={0} sx={{ bgcolor: "white", borderBottom: 1, borderColor: "divider" }}>
          <Toolbar>
            <MenuBook sx={{ mr: 2, color: "primary.main" }} />
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, fontWeight: 700, color: "primary.main" }}
            >
              🏰 Idioma.Quest
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body2" color="text.secondary">
                {user.displayName || user.email}
              </Typography>
              <IconButton onClick={handleMenu}>
                <Avatar
                  src={user.photoURL}
                  alt={user.displayName}
                  sx={{ width: 32, height: 32 }}
                />
              </IconButton>
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <MenuItem disabled>
                <Typography variant="body2" color="text.secondary">
                  {user.email}
                </Typography>
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout}>
                <Logout fontSize="small" sx={{ mr: 1 }} />
                Logout
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      )}

      <Suspense
        fallback={
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <AuthGuard SignInScreen={SignInScreen}>
          <LoggedInRouter />
        </AuthGuard>
      </Suspense>
    </Box>
  );
}

function App() {
  return (
    <ErrorBoundary FallbackComponent={GeneralErrorPage}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
